import { render, staticRenderFns } from "./TourDetails.vue?vue&type=template&id=d2584b3a"
import script from "./TourDetails.js?vue&type=script&lang=js&external"
export * from "./TourDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports